import { gql } from '@apollo/client';

export const CREATE_DRIVER = gql`
  mutation CreateDriver(
    $name: String
    $email: String
    $password: String
    $notificationsToken: String
    $volcanoDriverId: String
    $phone: String
    $profilePicURI: String
    $type: String
    $status: String
    $drivingCompanyId: String
    $loginMethod: LoginMethod
  ) {
    createDriver(
      name: $name
      email: $email
      password: $password
      notificationsToken: $notificationsToken
      volcanoDriverId: $volcanoDriverId
      phone: $phone
      profilePicURI: $profilePicURI
      type: $type
      status: $status
      drivingCompanyId: $drivingCompanyId
      loginMethod: $loginMethod
    ) {
      id
      firebaseId
      volcanoDriverId
      name
      email
      volcanoEmail
      phone
      loginMethod
      loginEnabled
      inVolcano
      inPrisma
      alternatePhone
      communicationLocale
      hasLoginCredentials
      name
      profilePicURI
      providerId
      received
      status
      type
      profilePicURI
      drivingCompany {
        id
      }
    }
  }
`;

export const UPDATE_DRIVER = gql`
  mutation UpdateDriver(
    $id: ID!
    $name: String
    $email: String
    $loginMethod: LoginMethod
    $disableLogin: Boolean
    $phone: String
    $type: String
    $status: String
    $drivingCompanyId: String
    $profilePicURI: String
  ) {
    updateDriver(
      id: $id
      name: $name
      email: $email
      loginMethod: $loginMethod
      disableLogin: $disableLogin
      phone: $phone
      type: $type
      status: $status
      drivingCompanyId: $drivingCompanyId
      profilePicURI: $profilePicURI
    ) {
      id
      firebaseId
      volcanoDriverId
      name
      email
      volcanoEmail
      phone
      loginMethod
      loginEnabled
      inVolcano
      inPrisma
      alternatePhone
      communicationLocale
      hasLoginCredentials
      name
      profilePicURI
      providerId
      received
      status
      type
      profilePicURI
      drivingCompany {
        id
      }
    }
  }
`;

export const CONNECT_DRIVER_TO_SERVICE = gql`
  mutation ConnectDriverToService($email: String!, $volcanoServiceId: String!) {
    connectDriverToService(email: $email, volcanoServiceId: $volcanoServiceId) {
      id
      drivers {
        id
        name
        phone
      }
    }
  }
`;

export const DISCONNECT_DRIVER_FROM_SERVICE = gql`
  mutation DisconnectDriverFromService(
    $email: String!
    $volcanoServiceId: String!
  ) {
    disconnectDriverFromService(
      email: $email
      volcanoServiceId: $volcanoServiceId
    ) {
      id
      drivers {
        id
        name
        phone
      }
    }
  }
`;
